import React from "react";

export default ({record}) => {
    return <span>Actualité {record.title ? `"${record.title}"` : ''}</span>;
}
